import { render } from "./MyCase.vue?vue&type=template&id=5cbc8a2b&scoped=true"
import script from "./MyCase.vue?vue&type=script&lang=ts"
export * from "./MyCase.vue?vue&type=script&lang=ts"

import "./MyCase.vue?vue&type=style&index=0&id=5cbc8a2b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5cbc8a2b"

export default script